import { required, integer, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState, product, activeModifiers) {
  const rules = {
    form: {
      quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter quantity.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
        minValue: helpers.withMessage(i18n.global.t('Quantity must be at least 1.'), minValue(1))
      },
      attributeSelections: {},
      modifierSelections: {}
    }
  };

  // Validate attributes — all must be selected
  if (product.attributes && product.attributes.length > 0) {
    rules.form.attributeSelections = {
      required: helpers.withMessage(
        i18n.global.t('Please select all options.'),
        (value) => {
          if (!value || typeof value !== 'object') return false;
          return Object.keys(value).length >= product.attributes.length;
        }
      )
    };
  }

  // Validate required modifiers
  if (activeModifiers && activeModifiers.length > 0) {
    rules.form.modifierSelections = {
      required: helpers.withMessage(
        i18n.global.t('Please select all required options.'),
        (value) => {
          for (const modifier of activeModifiers) {
            if (!modifier.is_required) continue;
            const sel = value ? value[modifier.id] : null;

            if (modifier.allow_multiple) {
              if (!sel || !Array.isArray(sel) || sel.length === 0) return false;
              if (modifier.min_options > 0 && sel.length < modifier.min_options) return false;
            } else {
              if (!sel) return false;
            }
          }
          return true;
        }
      )
    };
  }

  return rules;
};
